<div class="modal-container">
  <h2 class="modal-title">Confirmation</h2>
  <div class="modal-content">
    <p class="modal-text">
      You’re about to delete<br />
      <b>"{{ modelName }}"</b>
    </p>

    <p class="modal-text"> This action is irreversible and cannot be undone. </p>
  </div>

  <div class="modal-actions">
    <button class="btn btn-secondary" (click)="onCancel()"> NO </button>
    <button class="btn btn-primary" (click)="onConfirmDelete()"> YES </button>
  </div>
</div>
